// =====================================================================
// commande-prete/useClients.js — Commandes prêtes v2 (16-10-2026)
// =====================================================================
// Clients proposés dans le champ « Client » (GET /api/ready-orders/clients : clients
// actifs avec readyEnabled, tri alphabétique) — partagé par la liste, l'écran PDA et
// le chargement. clients = null tant que la liste n'est pas arrivée ; en cas d'échec,
// [] + le message (affiché par ChoixClient, qui dit alors « liste indisponible »).
// La liste est gardée 60 s (liste → commande → liste sur le Wi-Fi du dépôt : une seule
// requête) ; « Paramètres clients » l'oublie après chaque enregistrement (oublierClients).
// =====================================================================

import { useEffect, useState } from 'react';
import { readyOrders, errMsg } from '../../services/api.js';

const DUREE_MS = 60_000;
let cache = null;   // { promesse, t }

export function oublierClients() { cache = null; }

function lireClients() {
  if (cache && Date.now() - cache.t < DUREE_MS) return cache.promesse;
  const promesse = readyOrders.clients().then((l) => (Array.isArray(l) ? l : []));
  const entree = { promesse, t: Date.now() };
  cache = entree;
  // Un échec n'est jamais gardé : la page suivante redemande.
  promesse.catch(() => { if (cache === entree) cache = null; });
  return promesse;
}

export function useClientsCommandesPretes(actif = true) {
  const [clients, setClients] = useState(null);
  const [erreur, setErreur] = useState('');
  useEffect(() => {
    if (!actif) return undefined;
    let vivant = true;
    lireClients()
      .then((l) => { if (vivant) setClients(l); })
      .catch((e) => { if (vivant) { setClients([]); setErreur(errMsg(e)); } });
    return () => { vivant = false; };
  }, [actif]);
  return { clients, erreur };
}
